import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {TaskModel} from "../../models/task.model";
import {TaskStatusType} from "../../types/taskStatus.type";
import * as moment from "moment/moment";

export class taskEtaCtrl implements IController {

  task: TaskModel;
  timeZoneId: string;
  configZoneId: string;

  private timeZoneOffsetDiff: any;
  public taskStatusTypes: typeof TaskStatusType = TaskStatusType;
  public currentTime: number;

  constructor(private splitService: SplitService, private moment) {
  }

  $onInit() {
    this.timeZoneOffsetDiff = 0;
    this.currentTime = this.moment().valueOf();
  }

  $onChanges(changes) {
    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
    if (changes.timeZoneId && !changes.timeZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  }

  ////////////////////////////////////////////////////////////////////////

  checkTimeZoneOffsetDiff() {
    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, _.get(this.task, 'taskSpec.externalEta') || _.get(this.task, 'analysis.eta'));
    return this.timeZoneOffsetDiff !== 0;
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskEta', {
    bindings: {
      task: '<',
      timeZoneId: '<',
      configZoneId: '<?'
    },
    template: require('./task-eta.html').default,
    controller: taskEtaCtrl
  });
